import type { UnityMessage } from "@/betby/api/types";

export interface HostBridgeNavigateMessage {
  type: "BetbyNavigate";
  data: {
    url: string;
  };
}

export interface HostBridgeUrlChangeMessage {
  type: "BetbyUrlChange";
  data: {
    url: string;
  };
}

export type HostBridgeMessage =
  | UnityMessage
  | HostBridgeNavigateMessage
  | HostBridgeUrlChangeMessage;

export interface HostBridge {
  postMessage(message: HostBridgeMessage): boolean;
  sendBack(): boolean;
  sendRecharge(): boolean;
  sendLogin(): boolean;
  sendTokenExpired(message?: string, title?: string): boolean;
  sendCurrencyChange(currency: "sc" | "gc"): boolean;
  sendGetWallet(): boolean;
  sendNavigate(url: string): boolean;
  sendUrlChange(url: string): boolean;
  /** Request new session ticket from host (Unity/native app) */
  requestSessionTicket?(): Promise<string | null>;
}

let activeHostBridge: HostBridge | null = null;

export function registerHostBridge(bridge: HostBridge): void {
  activeHostBridge = bridge;
}

export function getHostBridge(): HostBridge | null {
  return activeHostBridge;
}

export function resetHostBridge(): void {
  activeHostBridge = null;
}
